import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import DisclosureCounselingRepository from '@/repositories/disclosureCounselingRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useDisclosureCounselingReportStore = defineStore({
    id: 'disclosureCounselingReport',
    state: () => ({
        RepType: '',
        RepData1: {},
        RepData2: {},
    }),
    getters: {},
    actions: {
        /**
         * 開示カウンセリングレポートAPI
         * @param {String} API_URL
         * @param {object} requestBody
         */
        async getDisclosureCounselingReportAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const disclosureCounselingRepository = new DisclosureCounselingRepository();
            try {
                const response = await disclosureCounselingRepository.getDisclosureCounselingReportApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.RepType = response.data.RepType;
                this.RepData1 = response.data.RepData1;
                this.RepData2 = response.data.RepData2;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.RepType = '';
            this.RepData1 = {};
            this.RepData2 = {};
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
